import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import Utils from '../../../utils/Utils';

class ChangePaymentInfoTask extends AbstractRequestTask {
    constructor(paramsPOST = {}) {
        super();
        this.paramsPOST = paramsPOST;
    }

    getMethod() {
        return 'POST';
    }

    getHeaders() {
        return {
            'Content-Type': 'application/x-www-form-urlencoded',
        };
    }

    getQueryStringParams() {
        const baseParams = super.getParams();
        delete baseParams.user_token;
        const params = Object.assign({}, baseParams, this.paramsPOST);
        const result = Utils.buildQueryParams(params);

        return result;
    }

    getUrl() {
        const http = 'https://';
        const url = Launcher.get('akamai_mfwk');
        const queryString = `?${this.getQueryStringParams()}`;
        return `${http}${url}/services/payway/changepaymentinfo${queryString}`;
    }

    isValid(data) {
        if (data.errors || !data.response || data.response === 'error') {
            return false;
        }
        return true;
    }

    success(data, b) {
        this.resolve(data);
    }
}

export default ChangePaymentInfoTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/ChangePaymentInfoTask.js